module.exports = "/_next/static/images/56f23bbbc29632e702a29b2fb247cc15-slide-2-small.png.webp";